import { create } from 'zustand';
import { api } from '../services/api';

interface Workspace {
  id: string;
  name: string;
  description: string | null;
  logo_url: string | null;
  role: string;
  members_count: number;
}

interface WorkspaceState {
  workspaces: Workspace[];
  activeWorkspace: Workspace | null;
  isLoading: boolean;
  setWorkspaces: (ws: Workspace[]) => void;
  setActiveWorkspace: (ws: Workspace | null) => void;
  fetchWorkspaces: () => Promise<void>;
}

export const useWorkspaceStore = create<WorkspaceState>((set, get) => ({
  workspaces: [],
  activeWorkspace: null,
  isLoading: false,

  setWorkspaces: (workspaces) => set({ workspaces }),

  setActiveWorkspace: (ws) => {
    if (ws) {
      localStorage.setItem('active_workspace_id', ws.id);
    } else {
      localStorage.removeItem('active_workspace_id');
    }
    set({ activeWorkspace: ws });
  },

  fetchWorkspaces: async () => {
    set({ isLoading: true });
    try {
      const { data } = await api.get('/workspaces');
      const workspaces = data.data;
      set({ workspaces, isLoading: false });

      // Auto-select workspace
      const savedId = localStorage.getItem('active_workspace_id');
      const current = get().activeWorkspace;
      if (!current && workspaces.length > 0) {
        const saved = workspaces.find((w: Workspace) => w.id === savedId);
        get().setActiveWorkspace(saved || workspaces[0]);
      }
    } catch {
      set({ isLoading: false });
    }
  },
}));
